import healthyfood from './images/healthyFood.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
export default function ThirdSection(){
    return(
        <div className="px-10 py-10 md:px-24 py-28" id="challenges"> 
          <div>
            <h2 className="text-3xl text-teal-custom-DarkCayan font-bold  align-middle flex justify-center">التحديات</h2>
            <p className='  text-base text-gray-700 font-medium py-10 leading-8 text-center'>
              سجل دخول عشان تعرف مستواك من أعلي خمس لاعبين
          </p>
          </div>
          {/* div contains three cards*/}
          <div className="flex justify-center flex-col md:flex-row gap-6 md:gap-12 py-10">
             {/* first card*/}
            <div className="h-auto w-full md:max-w-sm flex-1 border-red-600 border-2 bg-red-300/40 rounded-r-lg  md:rounded-r-lg p-3 flex flex-col justify-center items-center gap-3 transition-all duration-500 hover:scale-105 hover:shadow-md">
                <LazyLoadImage src={healthyfood} alt='challenges' className="w-44 h-44"/>
                <h4 className="text-xl font-medium font-semibold text-black"> اختبر أكلك </h4>
  
                <Link to="/challenge1">
                <button className='bg-gradient-to-r from-teal-custom-Poppy to-teal-custom-orange rounded-full text-white text-base p-3 font-semibold transition-all duration-500 tranform hover:scale-105'>ابدأ الان</button> 
                </Link>   
            </div>
             {/* second card*/}
             <div className="h-auto w-full md:max-w-sm flex-1 border-red-600 border-2 bg-red-300/40 rounded-lg md:rounded-none p-3 flex flex-col justify-center items-center gap-3 transition-all duration-500 hover:scale-105 hover:shadow-md">
                <LazyLoadImage src={healthyfood} alt='challenges' className="w-44 h-44"/>
                <h4 className="text-xl font-medium font-semibold text-black" >   تقدر تحافظ على ابتسامتك ؟  </h4>
                
                <Link to="/challenge2">
                <button className='bg-gradient-to-r from-teal-custom-Poppy to-teal-custom-orange rounded-full text-white text-base p-3 font-semibold transition-all duration-500 tranform hover:scale-105'>ابدأ الان</button>  
                </Link> 
            </div>
             {/* third card*/}
             <div className="h-auto w-full md:max-w-sm flex-1 border-red-600 border-2 bg-red-300/40 rounded-l-lg md:rounded-l-lg p-3 flex flex-col justify-center items-center gap-3 transition-all duration-500 hover:scale-105 hover:shadow-md">
                <LazyLoadImage src={healthyfood} alt='challenges' className="w-44 h-44"/>
                <h4 className="text-xl font-medium font-semibold text-black"> تعرف </h4>
                
                <Link to="/challenge3">
                <button className='bg-gradient-to-r from-teal-custom-Poppy to-teal-custom-orange rounded-full text-white text-base p-3 font-semibold transition-all duration-500 tranform hover:scale-105'>ابدأ الان</button> 
                </Link>  
            </div>
          </div>
          <div className='flex justify-center'>
            <Link to ='/leaderboard'>
            <button className='bg-gradient-to-r from-teal-custom-Poppy to-teal-custom-orange rounded-full text-white text-base p-3 font-semibold transition-all duration-500 tranform hover:scale-105' > عرض مستواك </button> 
            </Link> 
          </div>
        </div>
    )
}